import { useEffect, useState, useRef } from "react";
import "./login.css";
import introVideo from "/src/assets/intro_edited.mp4";
import facebookIcon from "/src/assets/icons/facebook.svg";
import instagramIcon from "/src/assets/icons/instagram.svg";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { DETECT_BROWSER, validateEmail } from "../../utils/Constants";
import SignIn from "../../components/ui/signInButton";
import AniversarioImg from "/src/assets/images/aniversario_cuarenta.png";
import { Image } from "primereact/image";

const dataEmpresa = [
  { id: 1, name: "Salmones de Chile Matriz" },
  { id: 2, name: "Salmo procesos" },
  { id: 3, name: "Aysen" },
  { id: 4, name: "Centro cultivo antartica" },
];

function login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [empresa, setEmpresa] = useState("0");
  const [isBtnAlternativeLoginDisabled, setBtnAlternativeLoginDisabled] =
    useState(true);
  const [isBtnAdLoginDisabled, setBtnAdLoginDisabled] = useState(false);
  const navigate = useNavigate();
  const selectEmpresa = useRef<HTMLSelectElement | null>(null);
  const emailRef = useRef<HTMLInputElement | null>(null);
  const passwordRef = useRef<HTMLInputElement | null>(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleEmpresaChange = (event: { target: { value: string } }) => {
    setEmpresa(event.target.value as string);
  };

  const handleAdLogin = () => {
    alert("Esperando Configuración AD cloud");
    navigate("*");
  };

  const handleLogin = () => {
    alert("En evaluación este acceso");
    navigate("*");
  };

  useEffect(() => {
    if (selectEmpresa.current?.value !== "0") {
      return setBtnAdLoginDisabled(true);
    }
  });

  useEffect(() => {
    if (selectEmpresa.current?.value == "0") {
      setErrorMessage("empresa sin seleccionar");
      return setBtnAlternativeLoginDisabled(true);
    }

    if (
      emailRef.current?.value !== undefined &&
      passwordRef.current?.value !== undefined
    ) {
      if (emailRef.current.value.length < 7) {
        setErrorMessage("Email incompleto");
        return setBtnAlternativeLoginDisabled(true);
      }
      if (!validateEmail(emailRef.current.value)) {
        setErrorMessage("Email no válido");
        return setBtnAlternativeLoginDisabled(true);
      }

      if (passwordRef.current.value.length < 5) {
        setErrorMessage("Password incompleto");
        return setBtnAlternativeLoginDisabled(true);
      }
    }

    return setBtnAlternativeLoginDisabled(false);
  });

  return (
    <div id="login-container">
      <div id="login-videobox">
        <video id="intro-video" autoPlay muted loop>
          <source src={introVideo} type="video/mp4" />
        </video>
      </div>
      <div
        id="login-actionbox"
        style={{
          padding: "20px",
        }}
      >
        <Image
          src={AniversarioImg}
          alt="40 Aniversario Salmones de Chile"
          width="300px"
          style={{
            marginBottom: "20px",
          }}
        />
        <h2
          style={{
            fontSize: "16px",
            fontStyle: "italic",
            fontFamily: "cursive",
          }}
        >
          Fishweb 1.0
        </h2>
        <p style={{ fontSize: "8px", marginTop: "-10px" }}>
          © Salmones de Chile S.A 2025
        </p>
        {/*<span style={styles.errorMessage}>{errorMessage}</span>*/}

        {isBtnAdLoginDisabled ? (
          <SignIn show={false} />
        ) : (
          <SignIn show={true} />
        )}

        {/*<div id="login-alternative-header">
          <div>
            <hr id="separator" />o ingresa con <hr id="separator" />
          </div>
        </div>

        <div id="login-actionform">
          <input
            ref={emailRef}
            className="inputform"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
          />
          <input
            ref={passwordRef}
            className="inputform"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
          />
        </div>
        <button
          style={
            isBtnAlternativeLoginDisabled
              ? styles.disabledLoginButton
              : styles.enabledLoginButton
          }
          className="buttonform"
          onClick={handleLogin}
          disabled={isBtnAlternativeLoginDisabled}
        >
          Ingresar
        </button>*/}

        <div id="login-footer-rrss">
          <img
            alt=""
            width="36px"
            src={facebookIcon}
            onClick={() => window.location.replace(`https://facebook.com`)}
          />
          <img
            alt=""
            width="36px"
            src={instagramIcon}
            onClick={() => window.location.replace(`https://instagram.com`)}
          />
          <div>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "#fffbeb" /* Fondo sutil amarillo/alerta */,
                border: "1px solid #fef3c7",
                padding: "8px 12px",
                borderRadius: "6px",
                marginTop: "15px",
              }}
            >
              {/* Icono de advertencia oficial de PrimeIcons */}
              <i
                className="pi pi-exclamation-triangle"
                style={{ color: "#d97706", fontSize: "14px" }}
              ></i>

              <span
                style={{
                  fontSize: "12px",
                  color: "#451a03",
                  fontFamily:
                    "var(--font-family, sans-serif)" /* Usa la fuente global del sistema */,
                  fontWeight: "500",
                }}
              >
                Para una óptima experiencia, se recomienda usar{" "}
                <strong>Google Chrome</strong> o <strong>Firefox</strong>.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  disabledLoginButton: {
    backgroundColor: "gray",
    color: "white",
    cursor: "not-allowed",
    margin: 10,
    borderRadius: "8px",
    border: "none",
    boxShadow: "0px 0px 10px 0px grey",
  },
  enabledLoginButton: {
    backgroundColor: "red",
    color: "white",
    cursor: "pointer",
    margin: 10,
    borderRadius: "8px",
    border: "none",
    boxShadow: "0px 0px 10px 0px grey",
  },
  disabledAdLoginButton: {
    backgroundColor: "gray",
    cursor: "not-allowed",
    boxShadow: "0px 0px 10px 0px grey",
    margin: "20px",
    height: "7%",
    padding: "10px",
    color: "white",
    fontFamily: "math",
    fontSize: "12px",
  },
  enabledAdLoginButton: {
    backgroundColor: "red",
    color: "white",
    cursor: "pointer",
    borderRadius: "8px",
    border: "none",
    boxShadow: "0px 0px 10px 0px grey",
    margin: "20px",
    height: "7%",
    padding: "10px",
    fontFamily: "math",
    fontSize: "12px",
  },
  errorMessage: {
    display: "inherit",
    fontSize: "10px",
    color: "#ff3d3d",
  },
};

export default login;
